export default "__VITE_ASSET__DZyYlswT__"